export var ValidateZH = (rule, value, callback) => {
  const reg = /^[\u4e00-\u9fa5]{0,}$/;
  if (value != '') {
    if (value.length > 14 || value.length < 2) {
      callback(new Error('字符长度不能小于2或大于14'));
    } else {
      if (!reg.test(value)) {
        callback(new Error('请按照要求输入正确的值'));
      }
    }
  } else {
    callback(new Error('请按照要求输入国家名称（英文）'));
  }
};
export var ValidateEN = (rule, value, callback) => {
  const reg = /^[A-Za-z]+$/;
  if (value != '') {
    if (value.length > 14 || value.length < 2) {
      callback(new Error('字符长度不能小于2或大于14'));
    } else {
      if (!reg.test(value)) {
        callback(new Error('请按照要求输入正确的值'));
      }
    }
  } else {
    callback(new Error('请按照要求输入国家名称（英文）'));
  }
};
export var ValidateLocale = (rule, value, callback) => {
  const reg = /^[A-Z]+$/;
  if (value != '') {
    if (value.length > 5 || value.length < 2) {
      callback(new Error('字符长度不能小于2或大于5'));
    } else {
      if (!reg.test(value)) {
        callback(new Error('请按照要求输入正确的值'));
      }
    }
  } else {
    callback(new Error('请按照要求输入国家码'));
  }
};
export var ValidateCode = (rule, value, callback) => {
  const reg = /^\d{2,7}$/;
  if (value != '') {
    if (value.length > 7 || value.length < 2) {
      callback(new Error('字符长度不能小于2或大于7'));
    } else {
      if (!reg.test(value)) {
        callback(new Error('请按照要求输入正确的值(只能是数字)'));
      }
    }
  } else {
    callback(new Error('请输入国家区号'));
  }
};

export var ValidateLineUrl = (rule, value, callback) => {

  const reg = /^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#])?$/
  if (value != '') {
    if (!reg.test(value)) {
      callback(new Error('请输入正确的域名或地址'))
    }
  } else {
    callback(new Error('请输入域名或地址'))
  }
  callback()


}
